import React, { useEffect, useState } from 'react';
import { Box, Stack, Typography, Chip } from '@mui/material';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';
import http from '../Api/http';
import { GetMyAssignedLocations } from '../Api/Api';

const PRIMARY = '#135F93';

const fmtDay = (v) => {
    if (!v) return '';
    const s = String(v).slice(0, 10);
    let d;
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) d = new Date(s);
    else if (/^\d{2}-\d{2}-\d{4}/.test(s)) { const [dd, mm, yy] = s.split('-'); d = new Date(+yy, +mm - 1, +dd); }
    else return s;
    return Number.isNaN(d.getTime()) ? s : d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
};

export default function MyAssignedLocations() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        let off = false;
        http.get(GetMyAssignedLocations)
            .then(({ data: body }) => {
                if (off || body?.error) return;
                const d = body?.data;
                const list = Array.isArray(d) ? d : (d?.data || d?.locations || d?.items || []);
                setItems(Array.isArray(list) ? list : []);
            })
            .catch(() => { });
        return () => { off = true; };
    }, []);

    if (!items.length) return null;
    const many = items.length > 1;

    return (
        <Box sx={{ borderRadius: '12px', overflow: 'hidden', mb: 2, border: `1px solid ${PRIMARY}2E`, boxShadow: `0 8px 22px -14px ${PRIMARY}88` }}>
            <Stack direction="row" spacing={1.2} sx={{ alignItems: 'center', px: 2, py: 1.3, background: `linear-gradient(135deg, ${PRIMARY} 0%, #2F8EBD 100%)`, color: '#fff' }}>
                <Box sx={{ width: 34, height: 34, borderRadius: '10px', bgcolor: 'rgba(255,255,255,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <PlaceRoundedIcon sx={{ fontSize: 20 }} />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ fontSize: 13.5, fontWeight: 800 }}>
                        You&apos;ve been assigned to {many ? `${items.length} work locations` : 'a work location'}
                    </Typography>
                    <Typography sx={{ fontSize: 11, opacity: 0.9 }}>Mark your attendance from the site — full details on the mobile app.</Typography>
                </Box>
            </Stack>

            <Stack sx={{ bgcolor: '#fff', p: 1.2 }} spacing={0.8}>
                {items.map((it, i) => {
                    const client = it.clientCompany ?? it.ClientCompany ?? it.clientName ?? '';
                    const place = it.locationName ?? it.LocationName ?? '';
                    const from = fmtDay(it.fromDate ?? it.FromDate);
                    const to = fmtDay(it.toDate ?? it.ToDate);
                    return (
                        <Stack key={i} direction="row" spacing={1.2} sx={{ alignItems: 'center', p: 1.1, borderRadius: '9px', border: '1px solid #EEF0F5', bgcolor: '#F3F8FC' }}>
                            <Box sx={{ width: 34, height: 34, borderRadius: '9px', bgcolor: `${PRIMARY}14`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <PlaceRoundedIcon sx={{ fontSize: 18, color: PRIMARY }} />
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1 }}>
                                <Typography sx={{ fontSize: 13.5, fontWeight: 800, color: '#111827' }} noWrap>{client || place || 'Assigned location'}</Typography>
                                {place && client && <Typography sx={{ fontSize: 11, color: '#98A0AE' }} noWrap>{place}</Typography>}
                            </Box>
                            {(from || to) && (
                                <Chip size="small" label={`${from}${to ? ` – ${to}` : ''}`} sx={{ height: 22, fontSize: 10.5, fontWeight: 700, bgcolor: '#E4F0F9', color: '#0E4A75', flexShrink: 0 }} />
                            )}
                        </Stack>
                    );
                })}

                <Stack direction="row" spacing={0.7} sx={{ alignItems: 'center', px: 0.4, pt: 0.2 }}>
                    <PhoneIphoneRoundedIcon sx={{ fontSize: 14, color: '#98A0AE' }} />
                    <Typography sx={{ fontSize: 11, color: '#98A0AE' }}>
                        Open the ARA HumanSync mobile app for directions and to check in at the location.
                    </Typography>
                </Stack>
            </Stack>
        </Box>
    );
}
